import { useState } from "react";
import { Button } from "../../../ui";
import { Download } from "../../../ui/icons";

// Compact download buttons for every file uploaded to a request (statements, tax
// invoices, contracts, signed contracts, attachments) - in progress and completed.
// The download goes through the request's authorized file endpoint (a short-lived
// signed URL, checked per request and per user by the server); nothing is linked
// directly from here.
const KIND_LABEL = (r, file) => ({ statement: r.downloadStatement, taxInvoice: r.downloadTaxInvoice, contract: r.downloadContract, signedContract: r.downloadSigned })[file.kind] || null;

export default function RequestFiles({ item, t, onOpenFile }) {
  const [busy, setBusy] = useState("");
  const files = (item.row?.files || []).filter((file) => file.id);
  if (!files.length) return null;
  const r = t.row;
  // several files of the same kind are told apart by their number, newest last
  const seen = {};
  const labelled = files.map((file) => {
    const base = KIND_LABEL(r, file) || r.downloadFile(file.name || "");
    seen[base] = (seen[base] || 0) + 1;
    return { file, base, index: seen[base] };
  });
  const total = (base) => labelled.filter((entry) => entry.base === base).length;

  const download = async (file) => {
    if (busy) return;
    setBusy(file.id);
    try {
      await onOpenFile?.(item.identity.id, { id: file.id, name: file.name, mimeType: file.mimeType });
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="lud-ur-files" role="group" aria-label={r.files}>
      {labelled.map(({ file, base, index }) => (
        <Button key={file.id} size="sm" appearance="soft" variant="neutral" icon={<Download size={14} />} loading={busy === file.id} disabled={Boolean(busy)} title={file.name || undefined} onClick={() => download(file)}>
          {total(base) > 1 ? `${base} (${index})` : base}
        </Button>
      ))}
    </div>
  );
}
